const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
const SEEN_NOTIFICATION = 'SEEN_NOTIFICATION';
const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'

const getNotifications = data => {
    return {
        type: GET_NOTIFICATIONS,
        data
    }
}

const seenNotification = (notificationId, pagination) => {
    return {
        type: SEEN_NOTIFICATION,
        notificationId,
        pagination
    }
}

const setNotificationsData = data => {
    return {
        type: SET_NOTIFICATIONS,
        data
    };
}

export default {
    types: {
        GET_NOTIFICATIONS,
        SEEN_NOTIFICATION,
        SET_NOTIFICATIONS
    },
    
    actions: {
        getNotifications,
        seenNotification,
        setNotificationsData
    }
}